import { Node } from "@tiptap/core";

const InlineImage = Node.create({
    name: "inlineImage",
    group: "inline",
    inline: true,
    atom: true,

    addAttributes() {
        return {
            src: {
                default: null,
            },
            width: {
                default: null,
            },
            height: {
                default: null,
            },
            alt: {
                default: "",
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: "img[data-inline-image][src]",
                priority: 60,
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            "img",
            {
                ...HTMLAttributes,
                "data-inline-image": "",
                style: "display: inline; vertical-align: middle;",
            },
        ];
    },
});

export default InlineImage;
